"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tline-height: ", ";\n\tmargin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Actions = _styledComponents.default.div(_templateObject(), _spacing.default.s4, _spacing.default.s3);

Actions.displayName = 'Actions';
/** @component */

var _default = Actions;
exports.default = _default;